import React from "react";
import FormFileUpload from "../components/FormFileUpload";

const DocumentUploadSection = ({
  formValues,
  onChangeInput,
  formErrors,
  assignRef,
  isReOnboard,
  isEdit,
  isApproval,
  handleFileView,
  handleFileDelete,
}) => {
  return (
    <div className="staff-onboarding-form-section">
      <div className="staff-onboarding-section-header">
        <h3 className="staff-onboarding-section-title">Document Upload</h3>
        <p className="staff-onboarding-section-subtitle">
          Upload required documents and certificates
        </p>
      </div>
      <div className="staff-onboarding-section-content">
        <div className="staff-onboarding-form-grid grid-3">
          <FormFileUpload
            label="Identity Proof (Aadhar/Voter ID/DL)"
            name="identityProof"
            accept="image/*,application/pdf"
            onChange={onChangeInput}
            error={formErrors?.identityProof}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("identityProof")}
            existingFile={
              isEdit || isApproval ? formValues.identityProof : null
            }
            onViewFile={handleFileView}
            value={formValues.identityProof}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />

          <FormFileUpload
            label="PAN Card"
            name="panCard"
            accept="image/*,application/pdf"
            onChange={onChangeInput}
            error={formErrors?.panCard}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("panCard")}
            existingFile={isEdit || isApproval ? formValues.panCard : null}
            onViewFile={handleFileView}
            value={formValues.panCard}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />

          <FormFileUpload
            label="10th Marksheet"
            name="markSheet10th"
            accept="image/*,application/pdf"
            onChange={onChangeInput}
            error={formErrors?.markSheet10th}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("markSheet10th")}
            existingFile={
              isEdit || isApproval ? formValues.markSheet10th : null
            }
            onViewFile={handleFileView}
            value={formValues.markSheet10th}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />

          <FormFileUpload
            label="12th Marksheet"
            name="markSheet12th"
            accept="image/*,application/pdf"
            onChange={onChangeInput}
            error={formErrors?.markSheet12th}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("markSheet12th")}
            existingFile={
              isEdit || isApproval ? formValues.markSheet12th : null
            }
            onViewFile={handleFileView}
            value={formValues.markSheet12th}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />

          <FormFileUpload
            label="Staff Photo"
            name="staffPhoto"
            accept="image/*"
            onChange={onChangeInput}
            error={formErrors?.staffPhoto}
            disabled={isReOnboard}
            required={true}
            onRef={assignRef("staffPhoto")}
            existingFile={isEdit || isApproval ? formValues.staffPhoto : null}
            onViewFile={handleFileView}
            value={formValues.staffPhoto}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />

          <FormFileUpload
            label="Bank Details (Passbook/Checkbook)"
            name="bankDetail"
            accept="image/*,application/pdf"
            onChange={onChangeInput}
            error={formErrors?.bankDetail}
            disabled={isReOnboard}
            required={false}
            onRef={assignRef("bankDetail")}
            existingFile={isEdit || isApproval ? formValues.bankDetail : null}
            onViewFile={handleFileView}
            value={formValues.bankDetail}
            onDelete={handleFileDelete}
            isApproval={isApproval}
            isEdit={isEdit}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentUploadSection;
